var exports = {
  "zr": "x31de4314--96ef6c--root",
  "O0": "x31de4314--96ef6c--rating",
  "oV": "x31de4314--96ef6c--reviews-count",
  "Om": "x31de4314--96ef6c--dot",
};

module.exports = exports;
